export default {
  name: 'PzMessageCba',
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  methods: {}
};